import styled from 'styled-components';

export const Link = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2081e2;
    background: rgba(32, 129, 226, 0.1);
    padding: 12px 24px;
    width: 100%;
    font-weight: 450;
    font-size: 14px;
    border-radius: 36px;
    transition: all 0.1s ease-in-out;

    &:hover {
        background: rgba(32, 129, 226, 0.3);
    }

    svg {
        margin-right: 8px;
    }
`;
